import { Controller } from '@hotwired/stimulus'

function isLeap(year = '') {
  if (year.length === 0) {
    return false
  }
  if (year % 4 === 0 && year % 100 !== 0) {
    return true
  }
  if (year % 400 === 0) {
    return true
  }

  return false
}

function createElementList(count) {
  const firstNode = document.createElement('option')
  firstNode.textContent = '---'
  firstNode.value = ''
  const nodeList = new Array(count).fill('').map((_, idx) => {
    const option = document.createElement('option')
    option.textContent = idx > 8 ? idx + 1 : ['0', idx + 1].join('')
    option.value = idx + 1

    return option
  })

  return [firstNode].concat(nodeList)
}

function getChildCount(month, isLeapYear) {
  const smallMonths = [4, 6, 9, 11]

  if (Number(month) === 2) {
    return isLeapYear ? 29 : 28
  }
  if (smallMonths.includes(Number(month))) {
    return 30
  }

  return 31
}

function appendOptions(element, month, isLeapYear) {
  const optionsCount = getChildCount(month, isLeapYear)
  const nodeList = createElementList(optionsCount)
  element.append(...nodeList)
}

function adjustOptions(element, month, isLeapYear) {
  while (element.firstChild) {
    element.removeChild(element.firstChild)
  }
  appendOptions(element, month, isLeapYear)
}

function disableElement(element) {
  element.setAttribute('disabled', 'disabled')
}

function adjustDayOptionsWithMonth(element) {
  const yearField = element.previousElementSibling
  const dayField = element.nextElementSibling
  const selectNumber = dayField.options[dayField.selectedIndex].text

  // 更新日期選項
  adjustOptions(dayField, element.value, isLeap(yearField.value))

  if (selectNumber !== '---' && selectNumber !== undefined) {
    const optionIndex = selectNumber.match(/^[0]*(\d+)$/)[1]
    if (dayField.options[optionIndex]) {
      dayField.options[optionIndex].setAttribute('selected', 'selected')
    } else {
      dayField.selectedIndex = 0
    }
  }

  if (selectNumber === '---') {
    dayField.selectedIndex = 0
  }

  ;[element, dayField, yearField].forEach((item) => {
    disableElement(item.options[0])
  })
}

export default class extends Controller {
  static targets = ['selectContainer']

  static values = {
    startDate: String,
    endDate: String,
    compensationStart: String,
  }

  /**
   *  Main & Callback
   */

  connect() {
    this.fullDateFlow()
  }

  dayHandler(e) {
    const dayField = this.selectContainerTarget.children[2]
    disableElement(dayField.options[0])
  }

  modifyDayOptionsByMonth(e) {
    const monthField = this.selectContainerTarget.children[1]
    adjustDayOptionsWithMonth(monthField)
  }

  adjustDisabledOptions(event) {
    const [selectedYear, selectedMonth, selectedDay] = Array.from(
      this.selectContainerTarget.children
    ).map((element) => Number(element.value))
    const [startYear, startMonth, startDay] = this.startDateValue
      .split('-')
      .map((item) => Number(item))
    const [endYear, endMonth, endDay] = this.endDateValue
      .split('-')
      .map((item) => Number(item))
    const [yearField, monthField, dayField] = [
      this.selectContainerTarget.children[0],
      this.selectContainerTarget.children[1],
      this.selectContainerTarget.children[2],
    ]

    if (event && yearField.isSameNode(event.target)) {
      if (!monthField.value) {
        monthField.classList.add('pulldown-date--error')
        monthField.style.backgroundColor = '#FFFBEB'
      }
      if (!dayField.value) {
        dayField.classList.add('pulldown-date--error')
        dayField.style.backgroundColor = '#FFFBEB'
      }
    }

    if (selectedYear === startYear && selectedMonth < startMonth) {
      monthField.selectedIndex = 0
    }
    if (selectedYear === endYear && selectedMonth > endMonth) {
      monthField.selectedIndex = 0
    }
    if (
      selectedYear === startYear &&
      selectedMonth === startMonth &&
      selectedDay < startDay
    ) {
      dayField.selectedIndex = 0
    }
    if (
      selectedYear === endYear &&
      selectedMonth === endMonth &&
      selectedDay > endDay
    ) {
      dayField.selectedIndex = 0
    }

    for (let i = 1; i < monthField.options.length; i += 1) {
      if (startYear === endYear && (i < startMonth || i > endMonth)) {
        monthField.options[i].setAttribute('disabled', true)
      } else if (selectedYear === startYear && i < startMonth) {
        monthField.options[i].setAttribute('disabled', true)
      } else if (selectedYear === endYear && i > endMonth) {
        monthField.options[i].setAttribute('disabled', true)
      } else {
        monthField.options[i].removeAttribute('disabled')
      }
    }

    for (let i = 1; i < dayField.options.length; i += 1) {
      if (
        selectedYear === startYear &&
        selectedMonth === startMonth &&
        i < startDay
      ) {
        dayField.options[i].setAttribute('disabled', true)
      }
      if (
        selectedYear === endYear &&
        selectedMonth === endMonth &&
        i > endDay
      ) {
        dayField.options[i].setAttribute('disabled', true)
      }
    }
  }

  /**
   *  Private Function
   */

  fullDateFlow() {
    const [yearField, monthField, dayField] =
      this.selectContainerTarget.children
    const yearAction = yearField.getAttribute('data-action') || ''
    const monthAction = monthField.getAttribute('data-action') || ''
    const dayAction = dayField?.getAttribute('data-action') || ''

    yearField.setAttribute(
      'data-action',
      [
        yearAction,
        'change->date-select#modifyDayOptionsByMonth',
        'change->date-select#adjustDisabledOptions',
      ].join(' ')
    )
    monthField.setAttribute(
      'data-action',
      [
        monthAction,
        'change->date-select#modifyDayOptionsByMonth',
        'change->date-select#adjustDisabledOptions',
      ].join(' ')
    )
    dayField.setAttribute(
      'data-action',
      [dayAction, 'change->date-select#dayHandler'].join(' ')
    )

    // 初始值
    adjustDayOptionsWithMonth(monthField)
    this.adjustDisabledOptions()
  }
}
